import { clampPercent } from "./util";

interface CoveragePayload {
  model_coverage_summary?: Record<string, string[]>;
  inputs_completeness_pct?: number;
}

const BUCKET_LABELS: Record<string, string> = {
  modeled: "已建模",
  heuristic: "启发式",
  unmodeled: "未建模",
};

const BUCKET_ORDER = ["modeled", "heuristic", "unmodeled"];

export function CoveragePanel({ payload }: { payload: unknown }) {
  const p = (payload ?? {}) as CoveragePayload;
  const coverage = p.model_coverage_summary ?? {};
  const completeness = clampPercent(p.inputs_completeness_pct);

  const hasCoverage = BUCKET_ORDER.some(
    (bucket) => (coverage[bucket]?.length ?? 0) > 0,
  );
  const hasCompleteness = typeof p.inputs_completeness_pct === "number";

  if (!hasCoverage && !hasCompleteness) {
    return <p className="muted small">没有模型覆盖数据。</p>;
  }

  return (
    <div className="coverage-block">
      {hasCompleteness ? (
        <div className="coverage-progress">
          <p className="muted small">数据完整度</p>
          <div className="coverage-bar">
            <span style={{ width: `${completeness}%` }} />
          </div>
          <p className="coverage-progress-value">{completeness}%</p>
        </div>
      ) : null}
      {hasCoverage ? (
        <div className="coverage-buckets">
          {BUCKET_ORDER.map((bucket) => {
            const items = coverage[bucket] ?? [];
            return (
              <div key={bucket} className={`coverage-bucket bucket-${bucket}`}>
                <p className="muted small">{BUCKET_LABELS[bucket] ?? bucket}</p>
                {items.length === 0 ? (
                  <p className="muted small">—</p>
                ) : (
                  <ul>
                    {items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
